import * as React from 'react';
import { SingleKeyValueComponent, ComplexValue } from 'ui';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { CaseLogDownloadContainerProps } from 'app/area/case/features/case-log-download';
import { ButtonInline } from 'ui/common/button/button-inline';

export interface LinkDownloadProps {
  createDownloader?: (blobId: number, name?: string) => Promise<void>;
}

export interface LinkDownloadTranslations {
  textDownloadName?: string;

  /**
   * @internal
   */
  childValues?: any;
  primaryKey?: ComplexValue<number>;
}

export interface LinkDownloadState {
  downloading: boolean;
}

export type CaseLogLinkProps = CaseLogDownloadContainerProps & LinkDownloadProps &
                               LinkDownloadTranslations & SingleKeyValueComponent<number>;

export class CaseLogLink extends React.Component<CaseLogLinkProps, LinkDownloadState> {
  public state: Readonly<LinkDownloadState> = {
    downloading: false
  };

  private onDownloadCaseLog = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.button !== 0) {
      return;
    }

    if (!this.state.downloading && this.props.valueItem.value) {
      const key = this.props.primaryKey && this.props.primaryKey.value;
      const blobId = this.props.valueItem.value;
      const initialName = this.props.textDownloadName + '-' + key;
      const appendedWithChildValues = this.props.childValues.map(v=>v.value.toString()).join('-');
      const downloadName = initialName + '-' + appendedWithChildValues;

      this.setState({ downloading: true } );
      await this.props.createDownloader(blobId, downloadName);
      this.setState({ downloading: false });
    }
  }

  public render() {

  const {label, valueItem} = this.props;

  return (
    valueItem && valueItem.value ?
      <ButtonInline onClick={this.onDownloadCaseLog}>
        {label && label.text} <MdKeyboardArrowRight />
      </ButtonInline>
    :null);
  }
}
